// Hero.tsx
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.2, 0.65, 0.3, 0.9]
      }
    }
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <motion.div 
          className="container"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <motion.div className="hero-preheading-container" variants={itemVariants}>
            <span className="hero-preheading">
              Welcome to
            </span>
            <a className="hero-logo" href="/" data-discover="true">
              <img src="/logo.png" alt="KWCD Logo" className="hero-logo-img" />
            </a>
          </motion.div>
          
          <motion.h1 
            className="hero-heading"
            variants={itemVariants}
          >
            <span className="heading-line">Kayamandi Women & Children Development</span>
            <span className="highlight">Projects</span>
          </motion.h1>
          
          <motion.p 
            className="hero-subtitle"
            variants={itemVariants}
          >
            Empowering women and children through education, support, and community development in Kayamandi.
          </motion.p>
          
          <motion.div 
            className="hero-stats"
            variants={itemVariants}
            style={{ marginTop: '2rem' }}
          >
            <div className="stat">
              <span className="stat-number">15+</span>
              <span className="stat-label">Years of Service</span>
            </div>
            <div className="stat">
              <span className="stat-number">1000+</span>
              <span className="stat-label">Lives Impacted</span>
            </div>
            <div className="stat">
              <span className="stat-number">50+</span>
              <span className="stat-label">Programs</span>
            </div>
          </motion.div>
        </motion.div>
        <div className="scroll-indicator">
          <span>Scroll to Explore</span>
          <div className="mouse">
            <div className="wheel"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;